import styled from 'styled-components';
import MyTable, { Column } from '../../../components/MyTable';
import { useEffect, useState } from 'react';

interface AuctionNearbyItem {
  rn: number;
  pnu: string;
  type: string;
  caseno: string;
  addr: string;
  start_date: string; // 경매신청일
  end_date: string; // 낙찰일
  days: number; // 소요기간
  appraisal_prc: string; // 감정가
  bid_prc: string; // 낙찰가
  bid_rate: number; // 낙찰가율
  bid_people: number; // 입찰자 수
  land_area: number; // 토지면적
  building_area?: number | null; // 건물면적
  land_prc: number; // 토지면적당 낙찰가
  building_prc?: number | null; // 건물면적당 낙찰가
  build_year?: number | null; // 사용승인일
  distance: number; // 거리
}

const formatNumber = (num: any) => {
  if (num === null || num === undefined || num === '' || isNaN(num)) return '';
  return Number(num).toLocaleString();
};

const formatDate = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('ko-KR');
};

const columns: Column<AuctionNearbyItem>[] = [
  {
    key: 'caseno',
    label: '사건번호/주소',
    align: 'left',
    render: (item) => (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 500 }}>{item.caseno || ''}</span>
        <span
          style={{
            fontSize: '0.85rem',
            color: '#787d87',
            marginTop: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 300,
          }}
        >
          {item.addr || ''}
        </span>
      </div>
    ),
  },
  {
    key: 'start_date',
    label: '경매신청일',
    align: 'center',
    render: (item) => formatDate(item.start_date) || '',
  },
  {
    key: 'end_date',
    label: '낙찰일',
    align: 'center',
    render: (item) => formatDate(item.end_date) || '',
  },
  {
    key: 'days',
    label: '소요 기간',
    align: 'right',
    render: (item) => (item.days ? item.days : ''),
    unit: '일',
  },
  {
    key: 'appraisal_prc',
    label: '감정가',
    align: 'right',
    render: (item) =>
      item.appraisal_prc ? formatNumber(item.appraisal_prc) : '',
    unit: '원',
  },
  {
    key: 'bid_prc',
    label: '낙찰가',
    align: 'right',
    render: (item) => (item.bid_prc ? formatNumber(item.bid_prc) : ''),
    unit: '원',
  },
  {
    key: 'bid_rate',
    label: '낙찰가율',
    align: 'right',
    render: (item) => (item.bid_rate ? item.bid_rate.toFixed(1) : ''),
    unit: '%',
  },
  {
    key: 'bid_people',
    label: '입찰자 수',
    align: 'right',
    render: (item) => (item.bid_people ? formatNumber(item.bid_people) : ''),
    unit: '명',
  },
  {
    key: 'land_area',
    label: '토지면적',
    align: 'right',
    render: (item) => (item.land_area ? formatNumber(item.land_area) : ''),
    unit: '㎡',
  },
  {
    key: 'building_area',
    label: '건물면적',
    align: 'right',
    render: (item) =>
      item.building_area ? formatNumber(item.building_area) : '',
    unit: '㎡',
  },
  {
    key: 'land_prc',
    label: '토지면적당 낙찰가',
    align: 'right',
    render: (item) => (item.land_prc ? formatNumber(item.land_prc) : ''),
    unit: '원',
  },
  {
    key: 'building_prc',
    label: '건물면적당 낙찰가',
    align: 'right',
    render: (item) =>
      item.building_prc ? formatNumber(item.building_prc) : '',
    unit: '원',
  },
  {
    key: 'build_year',
    label: '사용승인일',
    align: 'center',
    render: (item) => (item.build_year ? item.build_year : ''),
  },
  {
    key: 'distance',
    label: '거리',
    align: 'right',
    render: (item) => (item.distance ? item.distance.toFixed(1) : ''),
    unit: 'm',
  },
];

const AuctionNearby = ({
  data,
  selectionOptions,
  loading,
  isPremium = false,
}: {
  data: any[];
  selectionOptions: string[];
  loading: boolean;
  isPremium: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (loading) {
      setIsLoading(true);
    } else {
      const timer = setTimeout(() => setIsLoading(false), 300);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  return (
    <Wrap>
      <MyTable
        title="인근 주소 경매 낙찰 사례"
        selectionOptions={selectionOptions}
        columns={columns}
        data={data}
        avgKeys={[
          'days',
          'appraisal_prc',
          'bid_prc',
          'bid_rate',
          'bid_people',
          'land_area',
          'building_area',
          'land_prc',
          'building_prc',
        ]}
        loading={isLoading}
        isPremium={isPremium}
      />
    </Wrap>
  );
};

export default AuctionNearby;

const Wrap = styled.div`
  width: 100%;
  overflow-x: hidden;
  padding-top: 8px;
`;
